import { useEffect, useState } from 'react'
import { getFormCMSContent } from '../../../services/api/cms'
import { FormsProps, LAYOUT_TEMPLATE } from '../../../services/api/types'
import { BlockTitle } from '../../base'
import { Modal } from '../../modal'
import Forms from './Form'
import * as S from './FormWithModal.styled'

interface FormWithModalProps {
  slug: string
  template?: LAYOUT_TEMPLATE
  buttonText?: string
}

const FormWithModal = ({ slug, template, buttonText }: FormWithModalProps) => {
  const [form, setForm] = useState<FormsProps | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    const getFormFields = async () => {
      setIsLoading(true)

      try {
        const formData = await getFormCMSContent(null, {
          slug
        })

        setForm(formData)
      } catch (err) {
        console.error('Failed to load form data:', err)
      } finally {
        setIsLoading(false)
      }
    }

    if (slug) {
      getFormFields()
    }
  }, [slug])

  return !isLoading && !!form ? (
    <Modal
      className='form-modal'
      template={template}
      showCloseIcon
      buttonText={buttonText}
    >
      {slug && (
        <S.FormWrapper>
          <BlockTitle isYouFitness>{form.formTitle}</BlockTitle>
          <Forms
            layout='TwoColumn'
            slug={form.slug}
            fields={form.fields}
            postRedirectPage={form.postRedirectPage}
            title={form.title}
          />
        </S.FormWrapper>
      )}
    </Modal>
  ) : null
}

export default FormWithModal
